/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_B1certfileid4Inputs */

const en__field_b1certfileid4 = /** @type {(inputs: _Field_B1certfileid4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`German B1 certificate (PDF)`)
};

const de__field_b1certfileid4 = /** @type {(inputs: _Field_B1certfileid4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch-B1-Zertifikat (PDF)`)
};

/**
* | output |
* | --- |
* | "German B1 certificate (PDF)" |
*
* @param {_Field_B1certfileid4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_b1certfileid4 = /** @type {((inputs?: _Field_B1certfileid4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_B1certfileid4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_b1certfileid4(inputs)
	return de__field_b1certfileid4(inputs)
});
export { _field_b1certfileid4 as "_field_b1CertFileID" }